import Vue from 'vue'
import { Camera } from './cameras-fetcher'
import OverviewTab from './OverviewTab.vue'
import MailboxTab from './MailboxTab.vue'
import HelpTab from './HelpTab.vue'
import DeactivateTab from './DeactivateTab.vue'
import AssociateTab from './AssociateTab.vue'
import HistoryTab from './HistoryTab.vue'
import AlarmsAndVideosTab from './transmission/AlarmsAndVideosTab.vue'
// import TransmissionTab from './transmission/TransmissionTab.vue'
// import LogsTab from './LogsTab.vue'

export default new Vue({
  data() {
    return {
      // currentTab: 'overview',
      currentTab: 'alarmsAndVideos',
      id: null,
      row: null,
      originalStr: null
    }
  },
  computed: {
    tabItems() {
      return [
        { value: 'overview', label: 'Geral', component: OverviewTab },
        { value: 'mailbox', label: 'Mailbox', component: MailboxTab },
        { value: 'history', label: 'Histórico', component: HistoryTab },
        // {
        //   value: 'transmission',
        //   label: 'Transmissão',
        //   component: TransmissionTab
        // },
        {
          value: 'alarmsAndVideos',
          label: 'Alarmes e Vídeos',
          component: AlarmsAndVideosTab
        },

        { value: 'help', label: 'Help', component: HelpTab },
        // { value: 'logs', label: 'Logs', component: LogsTab },
        {
          value: 'associate',
          group: 'Operações',
          label: 'Assoc. Veículo',
          component: AssociateTab
        },
        {
          value: 'deactivate',
          group: 'Operações',
          label: 'Desativar',
          component: DeactivateTab
        }
      ]
    },
    isDirty() {
      return JSON.stringify(this.row) != this.originalStr
    }
  },
  methods: {
    async load(id) {
      this.id = id
      this.row = null
      const row = await Camera.findById(id)

      this.originalStr = JSON.stringify(row)
      this.row = row
    },

    async reload() {
      return await this.load(this.id)
    },

    async patch(body) {
      await Camera.patch(this.row.id, body)
      await this.load(this.row.id)
    },

    async deactivate() {
      await Camera.delete(this.row.id)
      await this.load(this.row.id)
    }
  }
})
